export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function loadScript(script_url : string) {
  return new Promise(function(resolve, reject) {
    var script = document.createElement('script');
    script.onload = resolve;
    script.onerror = reject;
    script.src = script_url
    document.head.appendChild(script);
  });
}